import { lazy } from 'react'
import { Lazy } from '../lazy'

const Page = lazy(() => import('./page'))

export default function LazyPage() {
    return <Lazy Page={Page} />
}